module.exports = __webpack_public_path__ + "static/media/events-icon-active-block.44c2919b.png";